import React from "react";
import { useStylesGeneral } from '../../styles/StyleComponents';
import AutoComplete from '../../common/ComponentesCS/AutoCompleteCS';
import DropDownListCS from '../../common/ComponentesCS/DropDownListCS';
import TeskMask from '../../common/ComponentesCS/TeskMaskCS';
import "../../styles/site.css";

function Otros() {
  const classes = useStylesGeneral();
  const [cargo, setCargo] = React.useState([]);

  const handleChange = event => {
    const { id, innerText } = event.target;
    if (id.includes("CelulaSolicitante")) {
      const CelulaSolicitante = innerText !== undefined ? innerText : '';
      setCargo({ ...cargo, CelulaSolicitante })
    }
  }

  return (<>
    <label className='tituloSeccion'>Cajas de texto</label>

    <div className={classes.root}>
      <br />
      <AutoComplete id="CelulaSolicitante" name={"CelulaSolicitante"} items={[{ label: 'TI', title: 'TI' }, { label: 'HP', title: 'HP' }]} acceso={handleChange} placeholder={"Selecciona una célula"} label={cargo.CelulaSolicitante} value={cargo.CelulaSolicitante} multiple={false} />
      <br />
      <DropDownListCS></DropDownListCS>
      <br />
      <TeskMask></TeskMask>
    </div>
  </>)
}

export default React.memo(Otros);